var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "doc-download-page" },
    [
      _c(
        "div",
        { staticClass: "hero" },
        [
          _vm._m(0),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.openCreate } },
            [_vm._v("新增文档")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "doc.docNo", label: "编号", "min-width": "140" },
              }),
              _c("el-table-column", {
                attrs: { prop: "doc.title", label: "标题", "min-width": "160" },
              }),
              _c("el-table-column", {
                attrs: { prop: "doc.category", label: "分类", width: "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "doc.downloadCount",
                  label: "下载",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "doc.status", label: "状态", width: "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(row.actions, function (action) {
                        return _c(
                          "el-button",
                          {
                            key: action,
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.runAction(row, action)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.actionText(action)))]
                        )
                      })
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("DOC DOWNLOAD")]),
      _c("h2", [_vm._v("文档下载")]),
      _c("p", [_vm._v("发布模板并统计下载次数。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }